import { render } from "./list-event.vue?vue&type=template&id=f8b06330"
import script from "./list-event.vue?vue&type=script&lang=js"
export * from "./list-event.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__